





















import { Component, Vue, Prop } from "vue-property-decorator";
import CountDwonTime from "@/components/CountDownTime/CountDownTime.vue";
@Component({
  components: {
    CountDwonTime
  }
})
export default class LimitStatus extends Vue {
  @Prop({ default: 0 })
  private limitedEndTimeStamp?: number;

  private shouldCloseLimit() {
    this.$emit("shouldCloseLimit");
  }
}
